import React from 'react'
import PropTypes from 'prop-types'

// Reusable wrapper component that greys out and disables children
const GlgDisabledWrapper = ({ disabled, children }) => {
  return (
    <div className={`${ disabled ? 'glg-disabled-element-wrapper' : ''}`}>
      {children}
    </div>
  )
}

GlgDisabledWrapper.propTypes = {
  disabled: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
}

export default GlgDisabledWrapper
